module.exports = __webpack_public_path__ + "static/img/bg-fr.2db9afcd.png";